module.exports = __webpack_public_path__ + "static/media/news.c9f5d9ad.png";